export const allowedDomainList = [
  'pracuj.localhost',
  'pracuj.pl',
  'pracuj-beta.pl',
  'www.pracuj.pl',
  'www.pracuj-beta.pl',
];
